import React from "react";
import { IconType } from "../../type/icon_type";

const IconWallet = (props: IconType) => {
  const { width = "24px", height = "24px", color = "#73787E", style } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M18.1579 7V4C18.1579 3.73478 18.0581 3.48043 17.8804 3.29289C17.7028 3.10536 17.4618 3 17.2105 3H4.89474C4.39222 3 3.91029 3.21071 3.55496 3.58579C3.19962 3.96086 3 4.46957 3 5M3 5C3 5.53043 3.19962 6.03914 3.55496 6.41421C3.91029 6.78929 4.39222 7 4.89474 7H19.1053C19.3565 7 19.5975 7.10536 19.7752 7.29289C19.9528 7.48043 20.0526 7.73478 20.0526 8V12M3 5V19C3 19.5304 3.19962 20.0391 3.55496 20.4142C3.91029 20.7893 4.39222 21 4.89474 21H19.1053C19.3565 21 19.5975 20.8946 19.7752 20.7071C19.9528 20.5196 20.0526 20.2652 20.0526 20V16M20.0526 12H17.2105C16.708 12 16.2261 12.2107 15.8707 12.5858C15.5154 12.9609 15.3158 13.4696 15.3158 14C15.3158 14.5304 15.5154 15.0391 15.8707 15.4142C16.2261 15.7893 16.708 16 17.2105 16H20.0526M20.0526 12C20.3039 12 20.5449 12.1054 20.7225 12.2929C20.9002 12.4804 21 12.7348 21 13V15C21 15.2652 20.9002 15.5196 20.7225 15.7071C20.5449 15.8946 20.3039 16 20.0526 16"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const IconWalletFilled = (props: IconType) => {
  const { width = "24px", height = "24px", color = "#73787E", style } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M3.55496 6.41421C3.19962 6.03914 3 5.53043 3 5V19C3 19.5304 3.19962 20.0391 3.55496 20.4142C3.91029 20.7893 4.39222 21 4.89474 21H19.1053C19.3565 21 19.5975 20.8946 19.7752 20.7071C19.9528 20.5196 20.0526 20.2652 20.0526 20V16H17.2105C16.708 16 16.2261 15.7893 15.8707 15.4142C15.5154 15.0391 15.3158 14.5304 15.3158 14C15.3158 13.4696 15.5154 12.9609 15.8707 12.5858C16.2261 12.2107 16.708 12 17.2105 12H20.0526V8C20.0526 7.73478 19.9528 7.48043 19.7752 7.29289C19.5975 7.10536 19.3565 7 19.1053 7H18.1579H4.89474C4.39222 7 3.91029 6.78929 3.55496 6.41421Z"
        fill={color}
      />
      <path
        d="M18.1579 7V4C18.1579 3.73478 18.0581 3.48043 17.8804 3.29289C17.7028 3.10536 17.4618 3 17.2105 3H4.89474C4.39222 3 3.91029 3.21071 3.55496 3.58579C3.19962 3.96086 3 4.46957 3 5M18.1579 7H19.1053M18.1579 7H4.89474M3 5C3 5.53043 3.19962 6.03914 3.55496 6.41421C3.91029 6.78929 4.39222 7 4.89474 7M3 5V19C3 19.5304 3.19962 20.0391 3.55496 20.4142C3.91029 20.7893 4.39222 21 4.89474 21H19.1053C19.3565 21 19.5975 20.8946 19.7752 20.7071C19.9528 20.5196 20.0526 20.2652 20.0526 20V16M4.89474 7H19.1053M19.1053 7C19.3565 7 19.5975 7.10536 19.7752 7.29289C19.9528 7.48043 20.0526 7.73478 20.0526 8V12M20.0526 12H17.2105C16.708 12 16.2261 12.2107 15.8707 12.5858C15.5154 12.9609 15.3158 13.4696 15.3158 14C15.3158 14.5304 15.5154 15.0391 15.8707 15.4142C16.2261 15.7893 16.708 16 17.2105 16H20.0526M20.0526 12C20.3039 12 20.5449 12.1054 20.7225 12.2929C20.9002 12.4804 21 12.7348 21 13V15C21 15.2652 20.9002 15.5196 20.7225 15.7071C20.5449 15.8946 20.3039 16 20.0526 16"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { IconWallet, IconWalletFilled };
